// required for AOT compilation
import { HttpClient } from '@angular/common/http';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';

export function I18nHttpLoaderFactory(http: HttpClient) {
    // ngx-translate/http-loader v17+ no longer accepts (http, prefix, suffix) in the constructor.
    // Configuration is provided via TRANSLATE_HTTP_LOADER_CONFIG (see AppModule).
    return new TranslateHttpLoader();
}
